import { ethers as r } from "ethers";
import { OptionContractAbi as c } from "@deorderbook/contracts/abi";
import { signer as e, provider as i } from "./provider.mjs";
const p = /* @__PURE__ */ new Map(), s = (t) => {
  const n = new r.Contract(
    t,
    c
  );
  return p.set(t, n), n;
}, f = (t, n = !1) => {
  const o = s(t);
  return n ? o.connect(e) : o.connect(i);
};
export {
  s as initOptionContract,
  p as optionContracts,
  f as useOptionContract
};
//# sourceMappingURL=optionContract.mjs.map
